import React, { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { updatePatientsInfo } from "../../../db/users";
import { createRange } from "../../../util/arraysUtil";
import Questionary from "../Questionary/Questionary";
import Container from "../../../ui/Container/Container";
import Modal from "../../../ui/Modal/Modal";

function PatientInfoQuestionary() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const key = location.state.key;
  const patient = location.state.patient;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [womacScore, setWomacScore] = useState(null);

  async function saveQuestionary(userAnswers) {
    const path = patient.key;
    const questionariesPath = `${patient.key}/questionaries/${key}`;
    let updateCompleted = undefined;
    if (key === "follow" || key === "final") {
      const womacScale = calculateWomac(createRange(6, 30), userAnswers);
      if (key === "follow") {
        updateCompleted = {
          isFollowCompleted: true,
          followAnsweredAt: new Date(),
          followWomac: womacScale,
        };
      } else {
        updateCompleted = {
          isFinalCompleted: true,
          finalAnsweredAt: new Date(),
          endWomac: womacScale,
        };
      }
      const womacElement = {
        answer: womacScale,
        key: userAnswers.length,
        question: "Escala WOMAC:",
        type: "open",
      };
      userAnswers.push(womacElement);
      await update(path, questionariesPath, updateCompleted, userAnswers);
      setWomacScore(womacScale);
      setIsModalVisible(true);
    } else {
      await update(path, questionariesPath, updateCompleted, userAnswers);
      alert("Cuestionario registrado con éxito.");
      navigate("/patientInfo", { state: { patientKey: patient.key } });
    }
  }

  async function update(
    rootPatientPath,
    questionaryPath,
    updateElement,
    userAnswers
  ) {
    if (updateElement) {
      await updatePatientsInfo(
        rootPatientPath,
        authCtx.userId,
        updateElement,
        authCtx.token
      );
    }
    await updatePatientsInfo(
      questionaryPath,
      authCtx.userId,
      {
        answers: userAnswers,
      },
      authCtx.token
    );
  }

  function calculateWomac(range, userAnswers) {
    let womacSum = 0;
    range.forEach((i) => {
      const ansValue = parseInt(userAnswers.find((a) => a.key === i).answer[0]);
      womacSum += ansValue;
    });
    return womacSum;
  }

  return (
    <>
      <Modal isOpen={isModalVisible} onClose={() => {
        setIsModalVisible(false);
        navigate("/patientInfo", { state: { patientKey: patient.key } });
      }}>
        <div style={{ margin: "10px" }}>
            <p style={{ color: "white", fontSize: "20px" }}>
              El paciente se ha creado exitosamente
            </p>
            <br />
            <p style={{ color: "white", fontSize: "20px" }}>
              La escala WOMAC es: {womacScore && womacScore}
            </p>
          </div>
      </Modal>
      <Container
        title="Cuestionario"
        backNavigation="/patientInfo"
        route={{ patientKey: patient.key }}
      >
        <Questionary
          questionaryId={key}
          token={authCtx.token}
          onSaveQuestionary={saveQuestionary}
        />
      </Container>
    </>
  );
}

export default PatientInfoQuestionary;
